import { lazyNamed } from 'src/utils/lazyNamed';

export const SizeConfigs = {
  List: lazyNamed(() => import('./containers/SizeConfigsList'), 'SizeConfigsList'),
};
